if (!customElements.get('discount-amount-tag')) {
    class DiscountTag extends StorePrice {
        constructor() {
            super();
            this.discountTagDom = this.querySelector('[data-discount-amount-tag-value]');
        }

        connectedCallback() {
            super.connectedCallback();
        }

        renderPrice() {
            // console.log('DiscountTag renderPrice called');
            const currentStorePrice = this.storesPrice[this.currentStoreCode];

            if (currentStorePrice && currentStorePrice.onSale === 'Y') {
                const diff = (currentStorePrice?.regionPrice - currentStorePrice?.webPrice).toFixed(2);

                if (diff > 0) {
                    this.discountTagDom.textContent = `save ＄${diff}`;
                } else {
                this.discountTagDom.textContent = '';
                }
            }
        }
    }

    customElements.define('discount-amount-tag', DiscountTag);
}